export default __webpack_public_path__ + "static/media/g.a5800b8a.png";